"use strict";

import React, {Component} from "react";
import {templates, PropTypes, ValueManager} from "Subschema";
const {FormTemplate} = templates;

export default class NestedFormTemplate extends Component {

    static contextTypes = {onSubmit: PropTypes.func};
    static childContextTypes = {valueManager: PropTypes.valueManager};
    static propTypes ={
        ...FormTemplate.propTypes,
        className:PropTypes.string
    };

    constructor(...args){
        super(...args);
        this.valueManager= ValueManager();
    }

    getChildContext(){
        return {valueManager: this.valueManager};
    }

    handleFormSubmit(e, err, value) {
        this.context.onSubmit(e, null, this.valueManager.getValue());
    }

    render(){
        return <FormTemplate {...this.props} onSubmit={this::this.handleFormSubmit} >
            {this.props.children}
            </FormTemplate>
    }
}




/** WEBPACK FOOTER **
 ** ./src/templates/NestedFormTemplate.jsx
 **/